var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCart = function SvgCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    clipPath: "url(#cart_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.833 1.833h1.595c.99 0 1.77.853 1.687 1.834l-.761 9.13a2.563 2.563 0 0 0 2.557 2.777h9.763c1.32 0 2.475-1.082 2.576-2.392l.495-6.875c.11-1.522-1.045-2.76-2.576-2.76H5.335M14.896 20.167a1.146 1.146 0 1 0 0-2.292 1.146 1.146 0 0 0 0 2.292M7.563 20.167a1.146 1.146 0 1 0 0-2.292 1.146 1.146 0 0 0 0 2.292M8.25 7.333h11"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "cart_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h22v22H0z"
  })))));
};
export default SvgCart;